<div class="popup-content" [attr.id]="data.equipment">
  <h4 class="header">Leuchtennummer {{ data.bstNumber }}</h4>
  <button class="popup-close-button" (click)="closePopup()">
    <img class="x-icon popup-close" alt="close-icon" src="../../../../assets/icons/close-icon-gray.svg" />
  </button>
  <hr class="hr" />
  <div [ngSwitch]="data.hasMultipleLamps">
    <div *ngSwitchCase="true">
      <div class="body">
        <div class="label-group">
          <label class="label">{{ data.address.street }} {{ data.address.number }}</label>
          <label class="sub-label">Aktuelle Position</label>
          <label class="label" *ngIf="mastHeight">Masthöhe: {{ mastHeight | number : '1.1-1' : 'es' }} m</label>
        </div>
        <div *ngFor="let lamp of data.lamps; trackBy: trackByFn">
          <hr class="hr" />
          <div class="label-group lamp" [ngClass]="{ active: lamp === selectedLamp }" (click)="showDetails(lamp)">
            <mat-checkbox (change)="checkChanged(lamp)" [(checked)]="lamp.selected" *ngIf="isClicked && isManualSelect && !lamp.isExcluded"></mat-checkbox>
            <div
              class="{{ mapService.getLampClass(lamp.lightLumenPerWatt, { isSelected: false, isHighlighted: false }) }}"
              [ngStyle]="mapService.getLampStylesHighlighted(lamp.colorCode, isHighlighted)"
            ></div>
            <label class="label lamp-label">{{ lamp.currentModel }}</label>
            <button class="chevron-show-lamp-detail" *ngIf="!(this.isManualSelect && isClicked)">
              <span class="fa fa-lg fa-chevron-right show-lamp-detail lamp-shown-{{ isLampDetailShown }}"></span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div *ngSwitchDefault>
      <div class="label-group">
        <label class="label" *ngIf="data.address.street">Adresse Straße: {{ data.lamps[0].address.street }}</label>
        <label class="label" *ngIf="data.address.number">Adressnummer: {{ data.lamps[0].address.number }}</label>
        <label class="sub-label">Aktuelle Position</label>

        <label class="label">Leuchtenform: {{ data.lamps[0].lightForm }}</label>
        <label class="label">Leuchtmitteltyp: {{ data.lamps[0].typeOfBulb }}</label>
        <label class="label">Leistung [W]: {{ data.lamps[0].sumPowerOfAllLuminaires | localNumber }}</label>
        <label class="label" *ngIf="mastHeight">Masthöhe: {{ mastHeight | number : '1.1-1' : 'es' }} m</label>
        <label class="label" *ngIf="data.actualLightType">Leuchtentyp: {{ data.lamps[0].actualLightType }}</label>
      </div>
    </div>
    <a class="footer" (click)="showSidebar()" *ngIf="!isManualSelect && !!authService.permissions.STREETLIGHT_PLANNER">
      <span class="label">Straßenbeleuchtungsplaner starten</span>
      <span class="fa fa-play-circle"></span>
    </a>
  </div>
</div>
<div class="popup-content lamp-detail" *ngIf="isLampDetailShown">
  <h4 class="header">{{ selectedLamp.currentModel }}</h4>
  <button class="popup-close-button" (click)="closeDetails()">
    <img class="x-icon close-lamp-detail" alt="close-icon" src="../../../../assets/icons/close-icon-gray.svg" />
  </button>
  <hr class="hr" />
  <div class="body">
    <div class="label-group">
      <label class="label">{{ selectedLamp.address.street }} {{ selectedLamp.address.number }}</label>
      <label class="sub-label">Aktuelle Position</label>
    </div>
    <label class="label">Leuchtenform: {{ selectedLamp.lightForm }}</label>
    <label class="label">Leuchtmitteltyp: {{ selectedLamp.typeOfBulb }}</label>
    <label class="label">Leistung [W]: {{ selectedLamp.sumPowerOfAllLuminaires | localNumber }}</label>
  </div>
</div>
